import Vue from 'vue'
import VueMask from 'v-mask'

import moment from 'moment'

import App from './App.vue'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'

import './styles/app.scss'


Vue.filter('truncate', (value, length) => {
  if (value == null) {
    return null
  }
  return value.length > length ? `${value.substring(0, length)}…` : value;
})

Vue.filter('defaultValue', (value, defaultValue) => {
  if (value == null || value.length === 0) {
    return defaultValue
  }

  return value
})

Vue.filter('formatDate', (value, format) => {
  if (value == null || value.length === 0) {
    return ''
  }

  return moment(value).locale(i18n.locale).format(format);
})

Vue.filter('formatFileSize', value => {
  if (value == null) {
    return ''
  }

  if (value < 1024) {
    return `${value} B`
  }

  if (value < 1024 * 1024) {
    return `${Math.round(value / 1024)} KB`
  }

  return `${(value / 1024 / 1024).toLocaleString(i18n.locale, { maximumFractionDigits: 1 })} MB`
})

Vue.filter('fromNow', value => {
  return moment(value).locale(i18n.locale).fromNow()
})

Vue.use(VueMask)

new Vue({
  i18n,
  render: h => h(App),
  router,
  store,
  vuetify
}).$mount('#app')